import React from "react";
import { useNavigate } from "react-router-dom";
import { Result, Button } from "antd";

// Page Not Found
export const InvalidPage = ({ subTitle }) => {

  const navigate = useNavigate();
  let path = `/`;

  const redirectHome = () => {
    navigate(path);
  };

  return (
    <>
      <Result
        status="404"
        title="404"
        subTitle={subTitle ? subTitle: "Sorry, unauthorised, invalid or expired token."}
        extra={<Button type="primary" onClick={redirectHome}>Back Home</Button>}
      />
    </>
  );
};

// export default InvalidPage;
